var React = require('react');
var helpers = require('svg-react-loader/helpers')(require('react-dom'));

module.exports = React.createClass({

    displayName: "ShippingBolt",

    getDefaultProps () {
        return {"xmlns":"http://www.w3.org/2000/svg","className":"dibsvg-svg dibsvg-shipping-bolt","viewBox":"0 0 250 250"};
    },

    componentDidMount () {
        helpers.applyXmlAttributes(this);
    },

    render () {
        var props = this.props;
        var children = props.children;

        return (
            <svg {...this.props}>
                  <path d="M225.5 83.6c0-.2 0-.3-.1-.5 0-.1 0-.1-.1-.2 0-.1-.1-.3-.1-.4 0-.1-.1-.2-.1-.2 0-.1-.1-.2-.2-.3 0-.1-.1-.1-.1-.2-.1-.1-.1-.2-.2-.3l-.2-.2c-.1-.1-.2-.2-.2-.3l-.2-.2c-.1-.1-.2-.2-.3-.2l-.2-.2h-.1c-.1-.1-.2-.1-.3-.2-.1 0-.1-.1-.2-.1-.2-.1-.4-.2-.6-.2l-49.2-16.5-5.7 7.5 41.8 14-55.6 27.7-28.5 14.2-4.5 5.8v105.3L42 193.8 33.6 90.9l53.7 26.9 3-8.9-49.2-25 43.7-14.7s-10.4-2.4-14.6-4L28.1 78.7c-.3.1-.6.2-.8.4-.5.1-.9.3-1.3.6-1.3.9-2.1 2.5-2 4.1l9.4 113.1c.1 1.5 1 2.8 2.3 3.5l87.3 49c.1 0 .2.1.2.1.1 0 .2.1.2.1.1 0 .2.1.3.1.1 0 .2.1.2.1.1 0 .3.1.4.1H125.9c.1 0 .3 0 .4-.1.1 0 .1 0 .2-.1.1 0 .2-.1.3-.1.1 0 .1-.1.2-.1s.2-.1.2-.1l87.7-46.9c1.4-.7 2.2-2.1 2.4-3.6l8.2-114.5v-.6-.2zm-16.9 112.1l-78.9 42.2V134.5l86.4-43-7.5 104.2z"/>
  <path d="M79.9 57.1l37.7 8.4L95 132.4c-.7 2.1.2 4.4 2.1 5.4.7.4 1.4.5 2.1.5 1.4 0 2.7-.6 3.6-1.8L168 50.3c1-1.3 1.2-2.9.6-4.4-.6-1.5-1.9-2.5-3.5-2.8l-43.4-6.9 6-31c.4-2-.6-4-2.4-4.9-1.8-.9-4-.5-5.3 1.1L77.5 49.7c-1 1.2-1.4 2.8-.9 4.3.5 1.6 1.7 2.7 3.3 3.1zm36-37.4l-3.8 19.4c-.2 1.2 0 2.4.7 3.4s1.8 1.7 3 1.9l40.6 6.4-44.2 58.3 15.4-45.5c.4-1.2.3-2.5-.3-3.6s-1.7-1.9-2.9-2.2L89.2 50l26.7-30.3z"/>
                {React.Children.map(children, (c) => (c))}
            </svg>
        );
    }
});



// WEBPACK FOOTER //
// ./src/shipping-bolt.svg